// extracted by mini-css-extract-plugin
export var actions = "_6u-8";
export var arrow = "_6u-5";
export var card = "_6u-0";
export var cardWrapper = "_6u-9";
export var fieldName = "_6u-3";
export var newValue = "_6u-6";
export var oldValue = "_6u-4";
export var orangeGlowFade = "_6u-c";
export var productSection = "_6u-1";
export var scrollToBottom = "_6u-b";
export var scrollToBottomAnchor = "_6u-a";
export var scrollToBottomIcon = "_6u-d";
export var showAllButton = "_6u-7";
export var table = "_6u-2";